import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageLoader } from "../../components/PageLoader";

/**
 * Settings → Integrations → Google's OAuth return, /settings/integrations/google-callback.
 *
 * GOOGLE_ADS_REDIRECT_URI still points Google at this panel path (backend .env), and the backend's
 * own bounce (GET /api/integrations/google/oauth-return) only takes over once that URI is changed.
 * Either way the code has to reach /settings/integrations/:id/connect-google, which exchanges it
 * (POST /api/integrations/google/callback with the user's login). `state` is the integration id the
 * sign-in started from (GET /api/integrations/google/auth-url?integration_id=…).
 *
 * IntegrationDetail renders this when its :id is "google-callback", so it works without its own route.
 */
export default function GoogleCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const state = params.get("state") || "";
  const valid = /^\d{1,10}$/.test(state);

  useEffect(() => {
    if (!valid) return;
    const qs = new URLSearchParams();
    if (params.get("code")) qs.set("code", params.get("code"));
    if (params.get("error")) qs.set("error", params.get("error"));
    navigate(`/settings/integrations/${state}/connect-google?${qs.toString()}`, { replace: true });
  }, [valid, state, params, navigate]);

  if (valid) return <PageLoader label="Connecting Google Ads…" />;
  return <main className="mx-auto max-w-5xl px-8 py-10"><Link to="/settings/integrations" className="flex w-fit items-center gap-2 text-small font-semibold text-sky-deep"><ArrowLeft size={16} />Back to integrations</Link><div className="mt-10 rounded-lg bg-paper p-8 shadow-soft"><h1 className="text-h3 font-semibold">Google didn't say which integration to connect</h1><p className="mt-2 text-small text-muted">Open the Google Ads integration and press “Sign in with Google” again.</p></div></main>;
}
